import L from "leaflet";
import "leaflet/dist/leaflet.css";

type Props = {
  cluster: any;
  iconType: string;
};

export const CustomClusterIcon = ({ cluster, iconType }: Props) => {
  const count = cluster.getChildCount();
  // console.log(cluster);
  const markers = cluster.getAllChildMarkers();
  const prices = markers.map((p: any) => p.options?.options ? p.options.options.price : 12000000);
  const min = Math.min(...prices);
  const max = Math.max(...prices);
  let badgeSize = "small"
  if (count > 10) badgeSize = "large";
  else if (count > 5) badgeSize = "medium";

  // const formatPrice = (n: number) => {
  //   if (n >= 1_000_000) {
  //     return (n / 1_000_000).toFixed(n % 1_000_000 === 0 ? 0 : 1) + "M";
  //   }
  //   if (n >= 1_000) {
  //     return (n / 1_000).toFixed(n % 1_000 === 0 ? 0 : 1) + "K";
  //   }
  //   return n.toString();
  // };
  const mPrice = (n: number) => {
    if (n >= 1000_000) {
      return (n / 1_000_000).toFixed(n % 1_000_000 === 0 ? 0 : 1) + "";
    }
    return '';
  };
  const range = `${mPrice(min)}~${mPrice(max)}M`;

  switch (iconType) {
    case "priceBadge":
      return L.divIcon({
        html: `<div class="cluster price-badge ${badgeSize}">${
          count
        }<br/><span>${range}</span></div>`,
        className: "custom-cluster",
        iconSize: [60, 60],
      });

    case "houseIcon":
      return L.divIcon({
        html: `<div class="cluster house-icon">🏠<span>${count}</span></div>`,
        className: "custom-cluster",
        iconSize: [50, 50],
      });

    case "pieChart":
      return L.divIcon({
        html: `<div class="cluster pie-chart">
                 <svg viewBox="0 0 36 36" class="circular-chart">
                   <path class="circle"
                     stroke-dasharray="60, 40"
                     d="M18 2.0845
                        a 15.9155 15.9155 0 0 1 0 31.831
                        a 15.9155 15.9155 0 0 1 0 -31.831"/>
                 </svg>
                 <span>${count}</span>
               </div>`,
        className: "custom-cluster",
        iconSize: [60, 60],
      });

    case "scaledCircle":
      const size = Math.min(80, 30 + count * 2);
      return L.divIcon({
        html: `<div class="cluster scaled" style="width:${size}px; height:${size}px;">
                 ${count}
               </div>`,
        className: "custom-cluster",
        iconSize: [size, size],
      });

    case "stackedCards":
      return L.divIcon({
        html: `<div class="cluster cards">
                 <div class="card"></div>
                 <div class="card"></div>
                 <div class="card main">${count}</div>
               </div>`,
        className: "custom-cluster",
        iconSize: [50, 50],
      });

    case "heatmap":
      return L.divIcon({
        html: `<div class="cluster heat" data-count="${count}">${count}</div>`,
        className: "custom-cluster",
        iconSize: [50, 50],
      });

    case "building":
      return L.divIcon({
        html: `<div class="cluster building">🏢<span>${count}</span></div>`,
        className: "custom-cluster",
        iconSize: [50, 50],
      });

    default:
      return L.divIcon({
        html: `<div class="cluster">${count}</div>`,
        className: "custom-cluster",
        iconSize: [40, 40],
      });
  }
}
